var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6H22V22H6V6ZM26 6H42V22H26V6ZM6 26H22V42H6V26ZM32 26H36V32H42V36H36V42H32V36H26V32H32V26ZM30 10V18H38V10H30ZM10 10V18H18V10H10ZM10 30V38H18V30H10Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDashboard);
export default __webpack_public_path__ + "static/media/custom-dashboard.ae152c5039478a184f0f412b7ad01817.svg";
export { ForwardRef as ReactComponent };